import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import ShieldAlertIcon from "@redotech/redo-icons/shield-zap.svg";
import ShieldAlertFilledIcon from "@redotech/redo-icons/shield-zap_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const FraudItem = memo(function FraudItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  const hasPermissionToViewItem = useHasPermission(
    ReturnsAndClaimsPermissions.VIEW_RETURN,
  );

  const anyChildSelected = useMatch(`${routes.fraudHref}/*`);

  if (!hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.fraudHref }}
      anyChildSelected={!!anyChildSelected}
      beta
      data-dd-action-name="returns_nav:fraud_link_click"
      FilledIcon={ShieldAlertFilledIcon}
      friendlyName={t("Fraud")}
      id="fraud"
      UnfilledIcon={ShieldAlertIcon}
    />
  );
});
